/** Common file extensions grouped by category */
export const FILE_EXTENSIONS = {
  IMAGE: ['.png', '.jpg', '.jpeg'],
  PDF: ['.pdf'],
  DOC: ['.doc', '.docx'],
} as const

/**
 * Check if a filename has one of the specified extensions.
 * @param filename - The filename to check (case-insensitive).
 * @param extensions - Extensions to match against (e.g. `['.png', '.jpg']`).
 * @returns Whether the filename ends with any of the given extensions.
 */
export const hasExtension = (filename: string, extensions: readonly string[]) =>
  extensions.some((ext) => filename.toLowerCase().endsWith(ext))

/** Check if file is an image (.png, .jpg, .jpeg) */
export const isImageFile = (filename: string) =>
  hasExtension(filename, FILE_EXTENSIONS.IMAGE)

/** Check if file is a PDF */
export const isPdfFile = (filename: string) =>
  hasExtension(filename, FILE_EXTENSIONS.PDF)

/** Check if file is a Word document (.doc, .docx) */
export const isDocFile = (filename: string) =>
  hasExtension(filename, FILE_EXTENSIONS.DOC)
